/*
 *   This file is part of 6502.ts, an emulator for 6502 based systems built
 *   in Typescript
 *
 *   Copyright (c) 2014 -- 2020 Christian Speckner and contributors
 *
 *   Permission is hereby granted, free of charge, to any person obtaining a copy
 *   of this software and associated documentation files (the "Software"), to deal
 *   in the Software without restriction, including without limitation the rights
 *   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the Software is
 *   furnished to do so, subject to the following conditions:
 *
 *   The above copyright notice and this permission notice shall be included in all
 *   copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 *   SOFTWARE.
 */

import DigitalJoystickInterface from './DigitalJoystickInterface';
import Switch from './Switch';
import SwitchInterface from './SwitchInterface';

export default class DigitalJoystick implements DigitalJoystickInterface {
    getLeft(): SwitchInterface {
        return this._left;
    }

    getRight(): SwitchInterface {
        return this._right;
    }

    getUp(): SwitchInterface {
        return this._up;
    }

    getDown(): SwitchInterface {
        return this._down;
    }

    getFire(): SwitchInterface {
        return this._fire;
    }

    private _left = new Switch();
    private _right = new Switch();
    private _up = new Switch();
    private _down = new Switch();

    private _fire = new Switch();
}
